<template>
  <div>
    <div class="collectType-box">
      <el-radio v-model="formData.collectType" label="INS" @change="doChangeCollectType">Instagram</el-radio>
      <el-radio v-model="formData.collectType" label="INS-TAG" @change="doChangeCollectType">Instagram话题</el-radio>
      <el-radio v-model="formData.collectType" label="XHS" @change="doChangeCollectType">小红书</el-radio>
    </div>
    <div class="search-box flex mt-10 ta-r">
      <div class="prepend" v-if="formData.collectType!='INS-TAG'">
        <el-input
          placeholder="请输入搜索内容"
          clearable
          v-model="formData.collectUserName"
          :readonly="isSearching"
          @keyup.enter.native="doSearch"
          @clear="doReset"
          @blur="doBlur">
          <!-- <el-select v-model="modelType" slot="prepend" placeholder="请选择">
            
            <el-option label="用户" value="users"></el-option>
            <el-option label="话题(暂未对接)" value="topic" disabled></el-option>
          </el-select> -->

        </el-input>
      </div>
      <div class="prepend" v-else>
        <el-select v-model="formData.collectKeyword" placeholder="请选择" style="width:100%">
          <el-option
            v-for="item in tagList"
            :key="item.tagId"
            :label="item.tagName"
            :value="item.tagName">
          </el-option>
        </el-select>
      </div>

      <div style="width:120px;">
        <el-button type="primary" icon="el-icon-search" @click="doSearch" :loading="isSearching">搜索</el-button>
      </div>
    </div>

    <div class="mt-20" v-if="formData.collectType!='INS-TAG'">
      <el-row :gutter="20">
        <el-col :span="12" v-for="(data,index) in list" :key="index">
          <el-card class="box-card" shadow="hover">
            <div class="author-box flex middle">
              
              <Avatar :src="data.headImgUrl"></Avatar>
              
              <div class="username-box">
                <p><b>{{data.fullName}}</b> <i class="el-icon-medal" v-if="data.officialCertification"></i></p>
                <p class="time">{{data.userName}}</p>
              </div>

              <div class="detail-box" style="display:none">
                <div>{{data.postCount}} 篇帖子</div>
                <div>{{data.fansCount}} 粉丝</div>
              </div>

              <div class="action-box">
                <el-button size="mini" icon="el-icon-star-on" disabled v-if="data.hasCollect">已加入采集名单</el-button>
                <el-button size="mini" icon="el-icon-star-off" v-else @click="doAddCollects(data)">加入采集名单</el-button>
                <br/>
                <el-button class="mt-5" size="mini" icon="el-icon-arrow-left" @click="doShowPostViewList(data)" >帖子预览</el-button>
              </div>
            </div>
          </el-card>

        </el-col>
      </el-row>
      

      <div class="ta-r" style="display:none">
        <el-pagination
          background
          hide-on-single-page
          layout="prev, pager, next"
          @current-change="doChangePage"
          :page-size="formData.size"
          :current-page="formData.page"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <div class="mt-20 searchResultBox" v-else>
      <el-skeleton style="width:100%" class="flex wrap postListBox mt-10" :loading="isSearching" animated >
        <template slot="template">
          <div style="margin-left:1.5%">PS: 每一次加载的内容很大可能都不一样, 需要重新采集, 等待时间较久.</div>
          <div class="flex wrap postListBox mt-10">
            <div class="postBox" v-for="(item, index) in 32" :key="index">
              <el-card :body-style="{ padding: '0px' }">
                <el-skeleton-item variant="image" animated :throttle="500" style="width: 100%;height:200px" />
                <div style="padding: 14px;">
                  <el-skeleton-item variant="p" animated :throttle="500" style="width: 50%" />
                  <div style="display: flex; align-items: center; justify-items: space-between;">
                    <el-skeleton-item variant="text" animated :throttle="500" style="margin-right: 16px;" />
                    <el-skeleton-item variant="text" animated :throttle="500" style="width: 30%;" />
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </template>
        <template>
          
          <div v-for="(item, index) in list2" :key="index" class="postBox">
            <el-card :body-style="{ padding: '0px' }" :id="'posting_'+item.post.extPostId">
              <Resources :list="item.post.resources"/>

              <div class="content-box">
                <div class="title" :class="{oneline:showIds.indexOf(item.post.extPostId)==-1}">{{item.post.title}} {{showIds.indexOf(item.post.extPostId)>-1}}</div>
                <div class="ta-r">
                  <el-button type="text" size="mini" @click="doHidePostTitle(item)" v-if="showIds.indexOf(item.post.extPostId)>-1">收起</el-button>
                  <el-button type="text" size="mini" @click="doShowPostTitle(item)" v-else>展开</el-button>
                </div>
                <div class="description">{{item.post.contents}}</div>
                <div class="bottom clearfix">
                  <time class="time">发布日期 {{ item.post.publishDate }}</time>
                </div>

                <el-divider></el-divider>

                <div class="author-box flex middle">
              
                  <Avatar :src="item.user.headImgUrl"></Avatar>

                  <div class="username-box">
                    <p><b>{{item.user.fullName}}</b> <i class="el-icon-medal" v-if="item.user.officialCertification"></i></p>
                    <p class="time">{{item.user.userName}}</p>
                  </div>

                  <div class="detail-box">
                    <div>{{item.post.commentCount}} 评论</div>
                    <div>{{item.post.upvoteNum}} 点赞</div>
                  </div>
                  
                </div>
                <div class="action-box ta-r mt-10">
                  <el-button size="mini" icon="el-icon-star-on" disabled v-if="item.user.hasCollect">已加入采集名单</el-button>
                  <el-button size="mini" icon="el-icon-star-off" v-else @click="doAddCollects(item.user,formData.collectKeyword)">加入采集名单</el-button>
                  <br/>
                  <el-button class="mt-5" size="mini" icon="el-icon-arrow-left" @click="doShowPostViewList(item.user)" >帖子预览</el-button>
                </div>
                
                <!-- <div v-if="userData && userData.userId">
                  <el-divider></el-divider>
                  <div class="ta-r">
                    <template v-if="item.isWaiting">
                      <el-button round type="info" class="button" size="mini" disabled>正在创建发布任务中,3秒后更新..</el-button>
                    </template>
                    <template v-else>
                      <template v-if="item.autoSyncing">
                        <template v-if="!item.syncing">
                          <p>( 计划 <time class="time">{{ item.publishDate }}</time> 发布 )</p>
                        </template>
                        <el-button round type="info" v-else class="button" size="mini" :loading="isSyncIdLoading == item.postingId" disabled>已自动同步 {{item.publishDate}}</el-button>
                      </template>
                      <template v-else>
                        <el-button round type="success" v-if="!item.syncing" class="button" size="mini" :loading="isSyncIdLoading == item.postingId" @click="doSyncById(item)">发布 / 编辑</el-button>
                        <el-button round type="info" v-else class="button" size="mini" disabled>已手动同步 {{item.syncingAt}}</el-button>
                      </template>
                    </template>
                    
                  </div>
                </div> -->
              </div>
              
            </el-card>
          </div>
        </template>
      </el-skeleton>
    </div>
    <el-drawer
    :visible.sync="isShowPostViewList"
    direction="ltr"
    size="50%"
    :withHeader="false"
    :close-on-press-escape="false"
    >
      <el-divider content-position="left">帖子预览(第一次加载会比较久)</el-divider>
      <PostList :collectUserId="currentData.collectUserId" :collectType="currentData.collectType" :extension="{}" :userData="currentData" :updateTimer="postUpdateTimer" />

    </el-drawer>

    <UserEdit :data.sync="currentData" :show.sync="showFormEdit" :isShowSetLater="true" />

    
  </div>
</template>

<script>
import PostList from '@/components/PostList';
import UserEdit from '@/components/UserEdit';
import Resources from '@/components/Resources';
export default {
  name: 'Home-Main',
  components: {
    UserEdit,PostList,Resources
  },
  data(){
    return {
      formData:{
        collectType:'INS',
        collectUserName:"",
        collectKeyword:"",
        page:1,
        size:6,
      },
      formEdit:{
        remark:"",
        tags:[]
      },
      currentData:{},
      modelType:"users",
      isSearching:false,
      isTagLoading:false,
      list:[],
      list2:[],
      showIds:[],
      tagList:[],
      total:0,
      showFormEdit:false,
      hasNext:false,
      isShowPostViewList:false,
      postUpdateTimer:0,
    };
  },
  watch: {
    showFormEdit(newData){
      if(!newData){
        this.doSearch();
      }
    }
  },
  mounted () {
    this.request.get(`/api/v1/tags?page=1&size=99`).then(res=>{
      if(!res){return;}
      this.tagList = res.results;
    })
  },
  methods: {
    doShowPostViewList(data){
      var collectType = this.formData.collectType == 'INS-TAG'?'INS':this.formData.collectType;
      this.currentData = {
        collectType,
        collectUserId:data.collectUserId
      }
      this.isShowPostViewList = true;
      this.postUpdateTimer = (new Date()).getTime();

    },
    getList(url){
      this.isSearching = true;
      this.request.get(url).then(res=>{
        this.isSearching = false;
        this.list = [];
        this.total = 0;
        this.formData.page = 1;
        if(!res){return ;}
        this.list = res.results || [];
        this.total = 999;// res.total;
        this.hasNext = res.hasNext;
        // this.total = 646;
        this.formData.page = res.page;

      });
    },
    getListForTagName(){
      this.isSearching = true;
      var params = this.$root.object2urlparams({
        collectKeyword: this.formData.collectKeyword,
        collectType: 'INS'
      });

      this.request.get(`/api/v1/collects/tagInfo?${params}`).then(data=>{
        this.isSearching = false;
        this.list2 = [];
        this.total = 0;
        this.formData.page = 1;
        if(!data){return ;}
        this.list2 = data || [];

      }).catch(error=>{
        this.isSearching = false;
        this.$message.error("返回超时,请稍候再试!");
        console.log(error);
      });
    },
    async doAddCollects(data,tagName=''){
      var params_arry = [
        "collectType",
        "collectUserId",
        "headImgUrl",
        "officialCertification",
        "userName",
        "fullName",
      ];

      var params = {
        customHeadImgUrl:"",
        extension:{},
        slowLifeUserId:"",
      };
      params_arry.map(p=>{
        if(typeof data[p] !=='undefined'){
          params[p] = data[p];
        } else {
          params[p] = '';
        }
      })

      this.showFormEdit = true;
      this.currentData = this.$root.copy(params);

      var url = `/api/v1/users/users`;
      var user = await this.request.post(url,params).then(res=>{
        if(res){
          this.currentData = this.$root.copy(res);
          this.$message.success("加入采集成功");
          this.showFormEdit = true;
          // this.doSearch();
          return res;
        }
      });
      if(tagName){
        this.doTagNameSubmit(user,tagName);
      }
    },
    async checkHasTagName(tagName){
      return await this.request.get(`/api/v1/tags?page=1&size=20&tagName=${tagName}`).then( async res=>{
        if(!res || !res.total){return false;}
        if(res.results && res.results.length){
          console.log(res.results);
          var target = res.results.find(t=>t.tagName == tagName);
          if(target && target.tagId){
            return target;
          } else {
            return false;
          }
        }
      });
    },
    async doCreateTag(tagName){
      return await this.request.post(`/api/v1/tags`,{tagName}).then(async res=>{
        return res;
      })
    },

    async doAddUserTag(userId,tagId){
      return await this.request.post(`/api/v1/users/${userId}/tag`,{tagId}).then(res=>{
        return res;
      });
    },

    async doTagNameSubmit(user,tagName){
      if(!user || !user.userId){return ;}
      tagName = tagName.replace(/(^\s*)|(\s*$)/g, "");

      if(!tagName){
        this.$message.warning("标签不能为空");
        return ;
      }

      var tag = await this.checkHasTagName(tagName);
      if(!tag){
        tag = await this.doCreateTag(tagName);
      }
      if(tag){
        await this.doAddUserTag(user.userId,tag.tagId);
      }
      this.$set(this.currentData,'tags',[tag]);
      
    },


    doSearch(){
      if(this.formData.collectType == 'INS-TAG'){
        if(!this.formData.collectKeyword){
          this.$message.warning("请选择搜索的标签");
          return ;
        }
        this.getListForTagName();
      } else {
        
        if(!this.formData.collectUserName){
          this.$message.warning("搜索内容不能为空");
          return ;
        }
        
        this.formData.page = 1;
        var params = this.$root.object2urlparams(this.formData);
        this.getList(`/api/v1/collects/${this.modelType}?${params}`);

      }
      
    },
    
    doChangeCollectType(){
      if(!this.formData.collectUserName){return ;}
      this.doSearch();
    },
    doChangePage(currentPage){
      console.log(currentPage);
      var formData = this.$root.copy(this.formData);
      formData.page = currentPage;
      var params = this.$root.object2urlparams(formData);
      this.getList(`/api/v1/collects/${this.modelType}?${params}`);
    },
    doBlur(){
      if(!this.formData.collectUserName){this.doReset();}
    },
    doReset(){
      this.list = [];
      this.total = 0;
      this.formData.page = 1;
      // this.formData.collectType = 'INS';

    },
    doHidePostTitle(item){
      var index = this.showIds.findIndex(s=>s == item.post.extPostId);
      if(index>-1){
        this.showIds.splice(index,1);
      }
      this.$nextTick(()=>{
        document.getElementById('posting_'+item.post.extPostId).scrollIntoView();
      });
    },
    doShowPostTitle(item){
      this.showIds.push(item.post.extPostId);
    }
  }
}
</script>

<style scoped lang="less">

.box-card,.searchResultBox{
  margin:10px 0;
  .author-box{
    position: relative;
    &>div{
      margin-left:15px;
      flex-shrink:0;
      &:first-child{margin-left:0;}
    }
    .avatar-box{
      
    }
    .username-box{
      font-size:14px;
      width:100%;
      flex-shrink:1;
      .time{font-size:12px;}
    }
    .detail-box{
      min-width:62px;
      text-align: right;
      flex-shrink:1;
    }
    .action-box{
      flex-shrink:1;
      font-size:14px;
      text-align: right;
    }
  }

}
</style>

<style lang="less">
.search-box{
  .prepend{
    width:100%;
    
  }
  
}
.searchResultBox{


  .postListBox{
    .postBox{
      width:30%;
      margin-left:1.5%;
      margin-right:1.5%;
      margin-bottom:3%;  
      &:nth-child(3n){
        margin-right:0%;
      }
      .content-box {
        padding: 14px;
        .title{
          font-size:14px;
          &.oneline{
            // white-space: nowrap; //强制文本在一行内输出
            // overflow: hidden; //隐藏溢出部分
            // text-overflow: ellipsis; //对溢出部分加上...

            display: -webkit-box !important;
            overflow: hidden;
            
            text-overflow: ellipsis;
            word-break: break-all;
            
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
        .description{
          font-size:12px;
        }
        .bottom{
          margin-top:5px;
          margin-bottom:5px;
          .button{
            float: right;
          }
        }
      }
    }
  }
}
</style>